export const style = {
    main: {
        marginBottom: 0
    },
    content: {
        fontSize: 'sm'
    }
};
